module.exports = __webpack_public_path__ + "img/search_logo.4b627911.png";